import nexo from '@tiendanube/nexo';

const instance = nexo.create({
  clientId: `${process.env.REACT_APP_NS_APP_ID}`,
  log: false,
});

export default instance;
